export default "/images/vendor/flag-icons/flags/4x3/fm.svg?18f7e08960b73974ccd456e9f2ff139a";